import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./globals.css";
import { createSameOriginBffClient } from "./api/http-client";
import { selectRuntimeClient } from "./api/runtime-client";
import { App } from "./App";
import { InboxFuryMarketingScreen } from "./screens/public/inboxfury-marketing-screen";

const root = document.getElementById("root");
if (!root) throw new Error("InboxFury application root is missing.");

const hostname = window.location.hostname;
const application = hostname === "inboxfury.com"
  ? <InboxFuryMarketingScreen />
  : (() => {
      const runtime = selectRuntimeClient(
        {
          production: import.meta.env.PROD,
          explicitDemo: false,
          hostname,
        },
        { bff: createSameOriginBffClient },
      );
      return <App client={runtime.client} dataMode={runtime.dataMode} />;
    })();

createRoot(root).render(
  <StrictMode>
    {application}
  </StrictMode>,
);
